// The server reports a chunk it could not read by position, e.g. `$.devices[98].DeviceStatus`, which
// says nothing about which line of the file to fix. This maps those positions back to file rows.
const JSON_PATH_PATTERN = /\$(?:\.devices)?\[(\d+)\](?:\.([A-Za-z0-9_]+))?/g;
const MAX_LISTED_ROWS = 10;

const describeRow = (row, chunkIndex) =>
  row
    ? `row ${row._rowNumber}${row.uniqueExternalId ? ` (${row.uniqueExternalId})` : ''}`
    : `row ${chunkIndex + 1} of this batch`;

export const addRowContextToChunkError = (message, chunk) => {
  const affected = new Map();
  [...message.matchAll(JSON_PATH_PATTERN)].forEach(([, index, column]) => {
    const columns = affected.get(Number(index)) || new Set();
    if (column) columns.add(column);
    affected.set(Number(index), columns);
  });
  if (affected.size === 0) {
    return message;
  }

  const entries = [...affected.entries()].sort(([first], [second]) => first - second);
  const listed = entries.slice(0, MAX_LISTED_ROWS).map(([index, columns]) => {
    const description = describeRow(chunk[index], index);
    return columns.size > 0 ? `${description}, column ${[...columns].join(', ')}` : description;
  });
  const remaining = entries.length - listed.length;
  const summary =
    entries.length === 1
      ? `The server could not read ${listed[0]}.`
      : `The server could not read ${entries.length} rows in this file: ${listed.join('; ')}${
          remaining > 0 ? ` ...and ${remaining} more` : ''
        }.`;

  return `${summary} Correct those cells in the file and upload it again.\n\nTechnical details: ${message}`;
};
